import React from "react";
import { Clearfix } from "react-bootstrap";
import MediaQuery from "react-responsive";

import Product from "components/Product";
import ico_open from "assets/images/contents/ico_open.png";
import ico_close from "assets/images/contents/ico_close.png";
import $ from "jquery";
import "./Category.css";

export default ({ category, handleProductSelect }) => {
  let toggleContent = e => {
    let target = $(e.target);
    if (target.next().css("display") === "block") {
      target.css("background-image", `url(${ico_open})`);
    } else {
      target.css("background-image", `url(${ico_close})`);
    }
    target.next().slideToggle();
  };
  let products = category.Products;
  let productsSection = (
    <div className="thumbnail">
      <div className="product-row">
        {products &&
          products.map(product => (
            <Product
              key={product.id}
              product={product}
              handleProductSelect={handleProductSelect}
            />
          ))}
      </div>
    </div>
  );
  return (
    <div className="content-products-thumbnail">
      {products.length !== 0
        ? <div>
          <MediaQuery maxDeviceWidth={767}>
            <h3 className="h3 thumbnail_open" onClick={(e) => toggleContent(e)}>
              {category.name}
            </h3>
            {productsSection}
          </MediaQuery>
          <MediaQuery minDeviceWidth={768}>
            <h3 className="h3 thumbnail_open">{category.name}</h3>
            {productsSection}
          </MediaQuery>
          <Clearfix />
        </div>
        : null
      }
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Category/Category.js